import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _has from 'lodash/has';
import { AppContext, UserContext } from 'commons-ui';
import useService from '../../../useService';
import { Record } from '../../../helper';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { user } = useContext(UserContext);
	const { requestCreateSegment } = useService();

	const createSegmentInfo = async (segmentData: Record) => {
		setShowLoader(true);
		try {
			const newSegmentData: Record = { ...segmentData };
			const currDate = Date.now();
			const userEmail = String(user?.email);
			newSegmentData.createdAt = currDate;
			newSegmentData.createdBy = userEmail;
			newSegmentData.updatedBy = userEmail;
			if (_has(newSegmentData, 'index')) {
				delete newSegmentData.index;
			}
			const response: boolean = await requestCreateSegment(newSegmentData, showAlert);
			if (response) history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: Record) => {
		createSegmentInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useCreate;
